document.addEventListener('DOMContentLoaded', function () {
  var swiper = new Swiper('.testimonials-slider', {
    slidesPerView: 1.2,       
    spaceBetween: 20,         
    loop: true,              
    watchOverflow: true,      
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 2.2    
      },
      1024: {
        slidesPerView: 3.2    
      },
      1440: {
        slidesPerView: 4.2    
      }
    }
  });
});
